import {ToastContainer} from 'react-toastify'

import {Breakpoint, useBreakpoint} from '@sdox/ui'

export const AppToastContainer = () => {
  const mdAndUp = useBreakpoint(Breakpoint.MD_AND_UP)
  return (
    <ToastContainer
      position={mdAndUp ? 'bottom-center' : 'top-center'}
      autoClose={3000}
      limit={1}
      hideProgressBar
      closeButton={false}
      pauseOnFocusLoss={false}
    />
  )
}
